// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___AwmyF","root__item":"style-module__root__item___s7JxB","root__title":"style-module__root__title___AlljU"};
    if(module.hot) {
      // 1697460476229
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  